import { http } from "@/lib/http";
import type { LoginResponse, User, UserCheckResponse } from "@/models";
import axios from "axios";

const allauthHttp = axios.create({
    baseURL: "/_allauth/browser/v1/auth/password",
    withCredentials: true,
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFToken",
    headers: { "X-Requested-With": "XMLHttpRequest" },
});

export const authService = {
    me: async (): Promise<User> => {
        const { data } = await http.get<User>("/auth/me/");
        return data;
    },
    login: async (payload: { username: string; password: string }) => {
        await http.post<LoginResponse>("/auth/login/", payload);
        return authService.me();
    },
    loginCode: async (key: string) => {
        await http.get<LoginResponse>(
            "/auth/login/?code=" + encodeURIComponent(key),
        );
        return authService.me();
    },
    checkUsernameType: async (
        username: string,
    ): Promise<UserCheckResponse | undefined> => {
        if (!username) return undefined;
        try {
            const { data } = await http.post<UserCheckResponse>(
                "/check-username/",
                {
                    username: username,
                },
            );
            return data;
        } catch (error) {
            console.error("Error checking username type:", error);
        }
    },
    logout: async () => {
        await http.post("/auth/logout/");
    },
    isValidResetKey: async (key: string) => {
        try {
            const response = await allauthHttp.get("/reset", {
                headers: {
                    "X-Password-Reset-Key": key,
                },
            });
            return response.status === 200;
        } catch {
            return false;
        }
    },
    requestPasswordReset: async (email: string) => {
        await allauthHttp.post("/request", { email });
    },
    resetPassword: async (key: string, password: string) => {
        await allauthHttp.post("/reset", {
            key,
            password,
        });
    },
};
